export default Object.freeze({
  OK: 200,
});
